// extracted by mini-css-extract-plugin
module.exports = {"title_title":"Title_title_title__33cqk"};